import React from 'react'
import anovaLogo from '../images/anova-logo.svg'
import { AnovaLogoStyled, AnovaLogoImage, AnovaLogoImageSmall } from './styled-components/AnovaLogo'

export const AnovaLogo = () => {
  return (
    <AnovaLogoStyled>
      <AnovaLogoImage src={anovaLogo} />
    </AnovaLogoStyled>
  )
}

export const AnovaLogoSmall = () => {
  return (
    <AnovaLogoStyled>
      <AnovaLogoImageSmall src={anovaLogo} />
    </AnovaLogoStyled>
  )
}
